import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loaders/orange-waiting.gif'


const _withScopeId = n => (_pushScopeId("data-v-1269ea8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex align-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"marginRight":"5px"}
}, null, -1))
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kbutton = _resolveComponent("kbutton")!

  return (_ctx.displayButton)
    ? (_openBlock(), _createBlock(_component_kbutton, {
        key: 0,
        class: "workflow-state-button",
        "theme-color": 'primary',
        icon: _ctx.lockIconState,
        size: 'large',
        disabled: !_ctx.isEnabled,
        hidden: _ctx.isHidden,
        onClick: _ctx.handleWorkflowStateChange
      }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("span", null, _toDisplayString(_ctx.buttonText), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.buttonText), 1))
        ]),
        _: 1
      }, 8, ["icon", "disabled", "hidden", "onClick"]))
    : _createCommentVNode("", true)
}